import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import { EMAIL_SUPPPORT } from "../../../config/constants";

export function useMenuItems({ iconClassName = "admin-menu__icon" } = {}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [current, setCurrent] = useState(
    location.pathname === "/" ? "/dashboard" : location.pathname,
  );

  useEffect(() => {
    setCurrent(location.pathname === "/" ? "/dashboard" : location.pathname);
  }, [location.pathname]);

  function sendEmailAction() {
    window.open(`mailto:${EMAIL_SUPPPORT}`);
  }

  const onClick = (e) => {
    setCurrent(e.key);
    if (e.key === "support") {
      sendEmailAction();
    } else {
      navigate(e.key);
    }
  };

  const items = [
    {
      label: "Dashboard",
      key: "/dashboard",
      icon: <SpaceDashboardOutlinedIcon className={iconClassName} />,
    },
    {
      label: "My Sites",
      key: "/accounts",
      icon: <CorporateFareOutlinedIcon className={iconClassName} />,
    },
    {
      label: "My Proposals",
      key: "/proposals",
      icon: <RequestQuoteOutlinedIcon className={iconClassName} />,
    },
    {
      label: "My Contracts",
      key: "/contracts",
      icon: <DescriptionOutlinedIcon className={iconClassName} />,
    },
    {
      label: "My Invoices",
      key: "/invoices",
      icon: <ReceiptLongOutlinedIcon className={iconClassName} />,
    },
    {
      label: "Support",
      icon: <SupportAgentOutlinedIcon className={iconClassName} />,
      key: "support",
    },
  ];

  return { items, current, onClick };
}
